<div class="main d-flex flex-column justify-content-center align-items-center">
  
  <img width="200" src="assets/icon-error404-01www.svg" alt="Cubatel - Llamadas, SMS, Recargas Nauta y Recargas a Cuba">
  <h2 class="text-center mt-5">¡Oh, no! Lo sentimos</h2>
  <p class="text-center mb-3">La página que buscas no existe o ha sido eliminada. Puedes:</p>
  <a class="btn btn-primary banner-button mt-xxl-5 mb-xxl-4" [routerLink]="['/']">Ir a la página principal</a>
  <ng-progress class="progress" #progressBar></ng-progress>
  <p class="text-center mt-3">O visitar nuestro centro de <a [routerLink]="['/asistencia']"
      routerLinkActive="active">Asistencia</a></p>
</div>